export default __webpack_public_path__ + "static/media/Front-Private-Diwania.e8584521.jpg";